module.exports = __webpack_public_path__ + "img/brand-icon10.327cba9f.jpg";